import React from 'react';
import PropTypes from 'prop-types';
import './index.less';
import { Menu as AntMenu } from 'antd';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import wrapReact from '../../../../util/react';
import { PATH_WEB_ACCOUNT, PATH_WEB_DEVICE } from '../../../../config';

export const Menu = (props) => {
  const {
    ui, filePath, className,
  } = props;
  return (
    <AntMenu
      mode="inline"
      theme="light"
      selectedKeys={ui.selectedKeys}
      className={`${filePath} ${className}`}
    >
      <AntMenu.Item key="device">
        <Link to={PATH_WEB_DEVICE}>
          <FormattedMessage id="Home.devices" defaultMessage="devices" />
        </Link>
      </AntMenu.Item>
      <AntMenu.Item key="account">
        <Link to={PATH_WEB_ACCOUNT}>
          <FormattedMessage id="Home.accounts" defaultMessage="accounts" />
        </Link>
      </AntMenu.Item>
    </AntMenu>
  );
};

Menu.propTypes = {
  ui: PropTypes.shape({
    selectedKeys: PropTypes.array.isRequired,
  }).isRequired,
  filePath: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
};

export default wrapReact(Menu, 'container_home_menuSider_Menu');
